// extracted by mini-css-extract-plugin
export var callCard = "_ky-0";
export var callMessageButton = "_ky-1";
export var helpIcon = "_ky-3";
export var helpIconContainer = "_ky-4";
export var verticalDivider = "_ky-2";